// Copyright (c) Ensho Health, 2021 to present

import { gql } from 'graphql-request';
import { workflowClient } from './client-gql.js';

export async function fetchPatient(patientId) {
  try {
    const query = gql`
      query patient($id: ID!) {
        patient(id: $id) {
          patientId
          clinicId
          chartNumberRedacted
          uniqueVendorIdSequenceRedacted
          yob
          sex
          physician
          mortality
          lastUpdated
        }
      }
    `;
    const variables = {
      id: patientId
    };
    const response = await workflowClient.request(query, variables);
    const patient = { ...response?.patient };
    if (patient) {
      patient.age = new Date().getFullYear() - parseInt(patient.yob);
    }
    return patient;
  } catch (error) {
    throw error;
  }
}
